module.exports = __webpack_public_path__ + "static/img/7.5fa96cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/zh/7.png
// module id = f9yX
// module chunks = 0